/**
 * React components that renders a carousel of sections
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Carousel from 'components/Carousel'
import BasicSection from '../Basic'
import TwoColumnSection from '../TwoColumn'

const CarouselSection = ({ sections }) => {
  const items = useMemo(() => sections.map(({
    id, type, body, ...props
  }) => {
    const updatedProps = {
      key: `carouselItem-${id}`,
      ...props,
    }

    switch (type) {
      case 'twoColumn':
        return (
          <TwoColumnSection {...updatedProps}>
            {body}
          </TwoColumnSection>
        )
      case 'basic':
      default:
        return (
          <BasicSection {...updatedProps}>
            {body}
          </BasicSection>
        )
    }
  }), [sections])

  return (items.length > 0) ? (
    <Carousel>
      {items}
    </Carousel>
  ) : null
}

CarouselSection.defaultPrpos = {
  sections: [],
}

CarouselSection.propTypes = {
  sections: PropTypes.array,
}

export default CarouselSection
